export default __webpack_public_path__ + "static/media/Globe Life.85262ef7.svg";